<script>
  import { format } from 'svelte-i18n';
  import { Col, Row, Spinner } from '@sveltestrap/sveltestrap';

  import { images, loadingAssets } from '@client/stores/assets';
  import { iconUrl, logoUrl } from '@client/stores/brand';

  import LogoChoice from './logo-choice.svelte';

  /**
   * Flag indicating if an image is currently being uploaded.
   * @type {boolean}
   */
  export let uploading;

  let iconUploading = false;
  let logoUploading = false;

  $: uploading = iconUploading || logoUploading;
</script>

<header>
  <h2>{$format('label.BRAND_WIZARD_STEP_LOGOS')}</h2>
  <p class="mb-3">
    {$format('label.BRAND_WIZARD_STEP_LOGOS_DESCRIPTION')}
  </p>
</header>

<Row>
  <Col>
    <div class="bold mb-2">{$format('label.LOGO')}</div>
    {#if $loadingAssets}
      <div class="border rounded p-5 text-center">
        <Spinner color="primary" />
      </div>
    {:else}
      <LogoChoice bind:uploading={logoUploading} bind:value={$logoUrl} images={$images} />
    {/if}

    <div class="mt-4 mb-2 bold">{$format('label.ICON')}</div>
    {#if $loadingAssets}
      <div class="border rounded p-5 text-center">
        <Spinner color="primary" />
      </div>
    {:else}
      <LogoChoice bind:uploading={iconUploading} bind:value={$iconUrl} images={$images} />
    {/if}
  </Col>
</Row>
